// Shared strings: user menu (the navbar labels stay fixed English in every language). Keys are read as $t('common.<key>').
export default {
  en: {
    loading: 'Loading…',
    menu: {
      title: 'Display settings',
      language: 'Language',
      orderHist: 'Order Hist',
      orderHistOld: 'Classic',
      orderHistNew: 'New',
      orderHistOldTitle: 'Original Order History page',
      orderHistNewTitle: 'Redesigned Order History page',
      textSize: 'Text size',
      sizeSmall: 'Small',
      sizeDefault: 'Default',
      sizeLarge: 'Large',
      sizeXLarge: 'Extra large',
      colorTheme: 'Color theme',
      custom: 'Custom',
      customTitle: 'Pick any colour',
      background: 'Background',
      bgStone: 'Stone',
      bgWhite: 'White',
      bgMist: 'Mist',
      surface: 'Surfaces',
      surfaceWhite: 'White',
      surfaceSoft: 'Soft',
      surfaceDim: 'Dim',
      guide: 'New Order Hist guide',
      guideTitle: 'Walk through the new Order Hist features',
      note: 'Applies to the new-style pages on this browser.',
    },
  },
  vi: {
    loading: 'Đang tải…',
    menu: {
      title: 'Cài đặt hiển thị',
      language: 'Ngôn ngữ',
      orderHist: 'Order Hist',
      orderHistOld: 'Cũ',
      orderHistNew: 'Mới',
      orderHistOldTitle: 'Giao diện Order Hist cũ',
      orderHistNewTitle: 'Giao diện Order Hist mới',
      textSize: 'Cỡ chữ',
      sizeSmall: 'Nhỏ',
      sizeDefault: 'Mặc định',
      sizeLarge: 'Lớn',
      sizeXLarge: 'Rất lớn',
      colorTheme: 'Màu giao diện',
      custom: 'Tuỳ chọn',
      customTitle: 'Chọn màu bất kỳ',
      background: 'Màu nền',
      bgStone: 'Xám đá',
      bgWhite: 'Trắng',
      bgMist: 'Xám nhạt',
      surface: 'Độ trắng',
      surfaceWhite: 'Trắng',
      surfaceSoft: 'Dịu',
      surfaceDim: 'Trầm',
      guide: 'Hướng dẫn Order Hist mới',
      guideTitle: 'Xem lần lượt các tính năng mới của Order Hist',
      note: 'Áp dụng cho các trang giao diện mới trên trình duyệt này.',
    },
  },
}
